import MxAlertIcon from "@rf-l1/alert/MxAlertIcon";
import MxEmptyBody from "@rf-l1/empty-sections/MxEmptyBody";
import MxEmptyCard, { MxEmptyCardProps } from "@rf-l1/empty-sections/MxEmptyCard";
import MxButton2 from "@rf-l1/buttons/MxButton2";
import React from "react";
import MxTypography from "@rf-l1/MxTypography";
import { Grid } from "@mui/material";

interface MxListEmptyTemplateWithFiltersProps {
  variant: "with-filters";
  title: string;
  description: string;
  button?: React.ReactNode;
  size?: MxEmptyCardProps["size"];
}

interface MxListEmptyTemplateSimpleProps {
  variant: "empty";
}

type MxListEmptyTemplateProps =
  | MxListEmptyTemplateWithFiltersProps
  | MxListEmptyTemplateSimpleProps;

const MxListEmptyTemplate = (props: MxListEmptyTemplateProps) => {
  if (props.variant === "empty") {
    return (
      <MxEmptyCard size="section">
        <MxAlertIcon type="info" />
        <MxEmptyBody>Sin resultados</MxEmptyBody>
      </MxEmptyCard>
    );
  }

  const {
    title = "¡Sin resultados!",
    description = "No se encontraron resultados para los filtros aplicados",
    button = <MxButton2 testId="clear-filters-button">Limpiar filtros</MxButton2>
  } = props;

  return (
    <MxEmptyCard size="section">
      <Grid
        container
        spacing={2}
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
      >
        <Grid item xs={12}>
          <MxTypography variant="subtitle1" color="primary.main">
            {title}
          </MxTypography>
        </Grid>
        <Grid item xs={12} md={8}>
          <MxTypography
            variant="caption"
            color="grey.500"
            fontWeight={400}
            textAlign="center"
          >
            {description}
          </MxTypography>
        </Grid>
        <Grid item xs={12}>
          {button}
        </Grid>
      </Grid>
    </MxEmptyCard>
  );
};

export default MxListEmptyTemplate;
